import { defineMessages } from './define'

/* Booking a doctor: the doctor list and profile, the slot grid, the payment
 * step and the payment sheets (online and offline). */

export default defineMessages({
  en: {
    'book.confirmedPill': 'Confirmed',
    'book.consultingDoctor': 'Consulting doctor',
    'book.dateTime': 'Date & time',
    'book.continuePay': 'Continue to payment',
    'book.bookingFor': 'Booking for patient',
    'book.availableToday': 'Available today',
    'book.consultFee': 'Consultation fee',
    'book.viewMonth': 'View month',
    'book.today': 'Today',
    'book.slotsN': '{n} slots',
    'book.slotsOne': '1 slot',
    'book.full': 'Full',
    'book.closedShort': 'Closed',
    'book.availableN': '{n} available',
    'book.availableParen': '({n} available)',
    'book.feeValue': 'Fee: {amount}',
    'book.summarySlot': 'Slot summary',
    'book.summaryFee': 'Payable',
    // booking screen
    'book.title': 'Book',
    'book.titleBook': 'Book Appointment',
    'book.titleMove': 'Move Appointment',
    'book.titleBooked': 'Booked',
    'book.payment': 'Payment',
    'book.payChoice.cash': 'Cash at clinic',
    'book.payChoice.upi': 'UPI',
    'book.payChoice.qr': 'Scan QR code',
    'book.errLoadDay': 'Could not load the day.',
    'book.errSearch': 'Could not search just now.',
    'book.timePassed': 'That time has already passed. Pick a later slot.',
    'book.overrideReasonNeeded': 'Give a reason for booking outside the schedule.',
    'book.theAppointment': 'The appointment',
    'book.errBook': 'Could not book.',
    'book.alreadyCheckedIn': "Already has today's visit with this doctor — token #{token}.",
    'book.checkedIn': 'Checked in — token #{token}. Record the vitals.',
    'book.errCheckIn': 'Could not check the patient in.',
    'book.waitMoving': 'We are moving\nyour appointment…',
    'book.waitBooking': 'We are booking\nyour appointment…',
    'book.waitFewSeconds': 'This should take a few seconds',
    'book.clinicFallback': 'Clinic',
    'book.checkingIn': 'Checking in…',
    'book.checkInVitals': 'Check in & record vitals',
    'book.shareTicketWhatsApp': 'Share ticket on WhatsApp',
    'book.payAmountNow': 'Pay {amount} now',
    'book.viewBooking': 'View booking',
    'book.viewBookings': 'View bookings',
    'book.backHome': 'Back to home',
    'book.movedDone': 'Appointment moved!',
    'book.bookedDone': 'Appointment booked!',
    'book.withDoctor': 'with {doctor}',
    'book.dateAtTime': '{date} at {time}',
    'book.dateAtTimePast': '{date} at {time} (already past)',
    'book.bookingRef': 'Booking {ref}',
    'book.dueNowOrClinic': '{amount} due — pay now or at the clinic.',
    'book.consultWith': 'Consultation with {doctor}',
    'book.paymentReceived': 'Payment received.',
    'book.paidSlotConfirmed': 'Payment received. Your slot is confirmed.',
    'book.pickTime': 'Pick a time',
    'book.giveReason': 'Give a reason',
    'book.accountNotLinked': 'Account not linked',
    'book.pickPatient': 'Pick a patient',
    'book.cannotBookDoctor': 'Cannot book this doctor',
    'book.loadingFee': 'Loading fee…',
    'book.ctaReviewMove': 'Review move to {time}, {date}',
    'book.ctaContinuePay': 'Continue to payment · {time}, {date}',
    'book.ctaConfirmPay': 'Confirm & pay {amount}',
    'book.ctaConfirmCash': 'Confirm · {amount} cash at the desk',
    'book.generalPractice': 'General practice',
    'book.selectDate': 'Select date',
    'book.pickAnyDate': 'Pick any date',
    'book.swipeDays': 'Swipe for more days, or tap the date above for any other day.',
    'book.moveReasonHead': 'Reason for the move',
    'book.currently': 'currently {time}, {code}',
    'book.whyMoved': 'Why is it being moved?',
    'book.whyMovedPh': 'Doctor called away, patient request…',
    'book.oldStays': 'The old booking stays on the record as rescheduled.',
    'book.yourAppointment': 'Your appointment',
    'book.notLinked': 'Your login is not linked to a patient record yet, so it cannot book. Ask the clinic to link it.',
    'book.change': 'Change',
    'book.addPatient': 'Add new patient',
    'book.recent': 'Recently added or updated',
    'book.searchHint': 'Search by name, mobile or patient code to pick someone.',
    'book.selectTime': 'Select time',
    'book.legendFree': 'Free',
    'book.legendChosen': 'Chosen',
    'book.legendBooked': 'Booked',
    'book.legendPassed': 'Passed',
    'book.loadingSlots': 'Loading slots…',
    'book.closedReason': 'Closed - {reason}. Pick another day.',
    'book.closed': 'Closed. Pick another day.',
    'book.noSessionsDay': 'The doctor does not see patients on this day.',
    'book.slot.booked': 'Booked',
    'book.slot.held': 'Being paid for',
    'book.slot.past': 'Past',
    'book.followUpRate': 'Follow-up rate, down from {fee}.',
    'book.followUpFee': 'Follow-up fee',
    'book.payNowQr': '{amount} is paid by scanning a QR to confirm the slot.',
    'book.payNowUpi': '{amount} is paid by UPI to confirm the slot.',
    'book.payCash': 'Paid in cash at the desk. The receipt is raised there.',
    'book.payMethod': 'Payment method',
    'book.holdNote': 'The slot is held for a few minutes while you pay, and booked the moment the payment is confirmed.',
    'book.override': 'Book anyway (override)',
    'book.overrideReason': 'Reason for the override',
    'book.overridePh': 'Walk-in seen earlier, doctor agreed to stay late…',
    'book.overrideHint': 'Recorded against the booking with your name.',
    'book.confirmMoveHead': 'Confirm the move',
    'book.confirmBookingHead': 'Confirm your booking',
    'book.paidNow': '{method} — paid now',
    'book.booking': 'Booking…',
    'book.confirmMoveBtn': 'Confirm move',
    'book.confirmBookingBtn': 'Confirm booking',

    // online payment sheet
    'book.qrFailed': 'The QR could not be drawn. Use another payment method.',
    'book.scanToPayAlt': 'Scan to pay',
    'book.slotHeldUntil': 'Your slot is held for you until {time} while you pay.',
    'book.errStartPayment': 'Could not start the payment.',
    'book.errNotThrough': 'The payment did not go through.',
    'book.notSeenYet': 'We have not seen the payment yet. If money has left your account it will show up shortly.',
    'book.errQr': 'Could not create a QR code.',
    'book.errSim': 'The simulated payment failed.',
    'book.openingPayment': 'Opening a secure payment…',
    'book.payAmount': 'Pay {amount}',
    'book.testMode': 'Test mode — no money moves. Choose what the bank should say.',
    'book.approve': 'Approve · {mode}',
    'book.decline': 'Decline',
    'book.scanQr': 'Scan QR',
    'book.redirect': 'You will be taken to {provider} to pay. The clinic never sees your card or UPI details.',
    'book.notNow': 'Not now',
    'book.payByQrInstead': 'Pay by scanning a QR instead',
    'book.scanToPay': 'Scan to pay {amount}',
    'book.openUpiApp': 'Open any UPI app — GPay, PhonePe, Paytm, your bank — and scan this.',
    'book.waitingPayment': 'Waiting for the payment…',
    'book.simulateScan': 'Simulate a scan',
    'book.confirmingPayment': 'Confirming your payment…',
    'book.dontClose': 'Please do not close this screen or pay again.',
    'book.paidTitle': 'Payment received',
    'book.paidLine': '{amount} paid — {title}.',
    'book.receiptNo': 'Receipt {no}',
    'book.notCompleted': 'Payment not completed',
    'book.somethingWrong': 'Something went wrong.',
    'book.failedDraft': 'Nothing has been charged and the slot has not been booked. Try again, or go back and choose to pay at the clinic.',
    'book.failedHeld': 'Your booking is still held. You can try again, or pay at the clinic.',

    // offline payment sheet
    'book.errRecord': 'Could not record the payment.',
    'book.recording': 'Recording the payment…',
    'book.recordTitle': 'Record {amount} received',
    'book.recordWarn': 'This records money the clinic already has. It does not charge anyone.',
    'book.txnNo': 'Transaction number',
    'book.txnPh': 'UTR, cheque number, UPI reference',
    'book.txnHint': 'Whatever the bank or the app calls it — this is what the statement is reconciled against.',
    'book.attachment': 'Attachment (optional)',
    'book.attachHint': 'Screenshot, receipt or scan if you have one. PDF or image, up to {mb} MB.',
    'book.fileTooBig': 'That file is over {mb} MB.',
    'book.noteOptional': 'Note (optional)',
    'book.notePh': 'Paid by the employer, cheque clears Friday…',
    'book.recordPayment': 'Record payment',
    'book.enterTxnFirst': 'Enter the transaction number before this can be saved.',

    // doctor list
    'book.chooseDoctor': 'Choose a doctor',
    'book.filters': 'Filters',
    'book.searchDoctors': 'Search doctors',
    'book.searchDoctorsPh': 'Search by name or specialty',
    'book.specialties': 'Specialties',
    'book.filterDoctors': 'Filter doctors',
    'book.specialty': 'Specialty',
    'book.any': 'Any',
    'book.feeUpTo': 'Consultation fee up to',
    'book.nobodyQueued': 'Nobody queued yet today',
    'book.orderBy': 'Order by',
    'book.sortRoster': 'Roster',
    'book.sortLoad': 'Lightest load',
    'book.clear': 'Clear',
    'book.showN': 'Show {n}',
    'book.noDoctorMatch': 'No doctor matches',
    'book.tryDifferent': 'Try a different name or specialty.',
    'book.viewProfile': 'View profile — {name}',
    'book.todayCount': '{n} today',
    'book.perConsultation': '/consultation',
    'book.book': 'Book',
    'book.bio': '{name} provides {spec} consultations at the clinic. Ask about availability and follow-up care before booking.',

    // doctor profile
    'book.recentChanges': 'Recent changes',
    'book.onYourBehalf': 'on your behalf',
    'book.errLoadBookings': 'Could not load the bookings.',
    'book.searchBooked': 'Search booked patients',
    'book.searchBookedPh': 'Patient name, code or mobile',
    'book.filterStatus': 'Filter by status',
    'book.bucketDone': 'Done',
    'book.filterPayment': 'Filter by payment',
    'book.loadingBookings': 'Loading bookings…',
    'book.nobodyBookedOn': 'Nobody booked on {date}',
    'book.nobodyMatches': 'Nobody matches these filters',
    'book.useArrows': 'Use the arrows to look at another day.',
    'book.clearSearch': 'Clear the search or pick another filter.',
    'book.amountPaid': '{amount} paid',
    'book.amountDue': '{amount} due',
    'book.doctorNotFound': 'Doctor not found.',
    'book.bookNow': 'Book Now',
    'book.doctorProfile': 'Doctor profile',
    'book.perVisit': '/visit',
    'book.message': 'Message',
    'book.onFile': 'On file',
    'book.qualifications': 'Qualifications',
    'book.notListed': 'Not listed',
    'book.registration': 'Registration',
    'book.inQueueToday': 'In queue today',
    'book.tabAbout': 'About',
    'book.tabBooked': 'Booked',
    'book.tabAvailability': 'Availability',
    'book.tabReviews': 'Reviews',
    'book.aboutDoctor': 'About the doctor',
    'book.seeMore': 'see more…',
    'book.credentials': 'Credentials',
    'book.regNo': 'Reg. no.',
    'book.missing': 'missing',
    'book.consultation': 'Consultation',
    'book.followUpTerms_one': '{fee} · within {n} day',
    'book.followUpTerms_other': '{fee} · within {n} days',
    'book.phone': 'Phone',
    'book.clinic': 'Clinic',
    'book.reviewsHead': 'Reviews & Ratings',
    'book.patientFeedback': 'Patient feedback',
    'book.reviewsNA': 'Reviews are not available yet',
    'book.reviewsNABody': 'Patient feedback will appear here once the clinic starts collecting it.',
    'book.todaySessions': 'Today’s sessions',
    'book.closedTodayReason': 'Closed today — {reason}.',
    'book.closedToday': 'Closed today.',
    'book.noSessionsToday': 'No sessions set for today.',
    'book.sessionBooked': '{count} booked',
    'book.inTheQueue': 'In the queue',
    'book.yourList': 'Your list',
    'book.openConsult': 'Open the consulting room',
    'book.manageAvailability': 'Manage availability',
    'book.yourHours': 'Your hours',
    'book.onBehalfOf': 'On behalf of {name}',
    'book.onlyCanChange': 'Only {name}, reception or an administrator can change these hours.',
  },
  hi: {
    'book.confirmedPill': 'पक्की',
    'book.consultingDoctor': 'परामर्श डॉक्टर',
    'book.dateTime': 'तारीख़ और समय',
    'book.continuePay': 'भुगतान पर आगे बढ़ें',
    'book.bookingFor': 'मरीज़ के लिए बुकिंग',
    'book.availableToday': 'आज उपलब्ध',
    'book.consultFee': 'परामर्श शुल्क',
    'book.viewMonth': 'महीना देखें',
    'book.today': 'आज',
    'book.slotsN': '{n} स्लॉट',
    'book.slotsOne': '1 स्लॉट',
    'book.full': 'भरा हुआ',
    'book.closedShort': 'बंद',
    'book.availableN': '{n} उपलब्ध',
    'book.availableParen': '({n} उपलब्ध)',
    'book.feeValue': 'शुल्क: {amount}',
    'book.summarySlot': 'स्लॉट सारांश',
    'book.summaryFee': 'देय',
    'book.title': 'बुक करें',
    'book.titleBook': 'अपॉइंटमेंट बुक करें',
    'book.titleMove': 'अपॉइंटमेंट का समय बदलें',
    'book.titleBooked': 'बुक हो गई',
    'book.payment': 'भुगतान',
    'book.payChoice.cash': 'क्लिनिक पर नकद',
    'book.payChoice.upi': 'UPI',
    'book.payChoice.qr': 'QR कोड स्कैन करें',
    'book.errLoadDay': 'इस दिन की जानकारी लोड नहीं हो सकी।',
    'book.errSearch': 'अभी खोज नहीं हो सकी।',
    'book.timePassed': 'यह समय निकल चुका है। कृपया बाद का कोई स्लॉट चुनें।',
    'book.overrideReasonNeeded': 'तय समय से बाहर बुक करने का कारण लिखें।',
    'book.theAppointment': 'अपॉइंटमेंट',
    'book.errBook': 'बुकिंग नहीं हो सकी।',
    'book.alreadyCheckedIn': 'इस डॉक्टर के साथ आज की विज़िट पहले से है — टोकन #{token}।',
    'book.checkedIn': 'चेक-इन हो गया — टोकन #{token}। अब वाइटल्स दर्ज करें।',
    'book.errCheckIn': 'मरीज़ का चेक-इन नहीं हो सका।',
    'book.waitMoving': 'आपकी अपॉइंटमेंट का\nसमय बदला जा रहा है…',
    'book.waitBooking': 'आपकी अपॉइंटमेंट\nबुक हो रही है…',
    'book.waitFewSeconds': 'इसमें कुछ ही सेकंड लगेंगे',
    'book.clinicFallback': 'क्लिनिक',
    'book.checkingIn': 'चेक-इन हो रहा है…',
    'book.checkInVitals': 'चेक-इन करें और वाइटल्स दर्ज करें',
    'book.shareTicketWhatsApp': 'WhatsApp पर टिकट भेजें',
    'book.payAmountNow': 'अभी {amount} का भुगतान करें',
    'book.viewBooking': 'बुकिंग देखें',
    'book.viewBookings': 'बुकिंग देखें',
    'book.backHome': 'होम पर वापस जाएँ',
    'book.movedDone': 'अपॉइंटमेंट का समय बदल गया!',
    'book.bookedDone': 'अपॉइंटमेंट बुक हो गई!',
    'book.withDoctor': '{doctor} के साथ',
    'book.dateAtTime': '{date}, {time} बजे',
    'book.dateAtTimePast': '{date}, {time} बजे (समय निकल चुका है)',
    'book.bookingRef': 'बुकिंग {ref}',
    'book.dueNowOrClinic': '{amount} बाकी — अभी भुगतान करें या क्लिनिक पर।',
    'book.consultWith': '{doctor} से परामर्श',
    'book.paymentReceived': 'भुगतान मिल गया।',
    'book.paidSlotConfirmed': 'भुगतान मिल गया। आपका स्लॉट पक्का हो गया है।',
    'book.pickTime': 'समय चुनें',
    'book.giveReason': 'कारण लिखें',
    'book.accountNotLinked': 'खाता जुड़ा नहीं है',
    'book.pickPatient': 'मरीज़ चुनें',
    'book.cannotBookDoctor': 'इस डॉक्टर के साथ बुक नहीं हो सकता',
    'book.loadingFee': 'फ़ीस लोड हो रही है…',
    'book.ctaReviewMove': 'नया समय जाँचें: {time}, {date}',
    'book.ctaContinuePay': 'भुगतान पर जाएँ · {time}, {date}',
    'book.ctaConfirmPay': 'पक्का करें और {amount} का भुगतान करें',
    'book.ctaConfirmCash': 'पक्का करें · {amount} काउंटर पर नकद',
    'book.generalPractice': 'सामान्य चिकित्सा',
    'book.selectDate': 'तारीख चुनें',
    'book.pickAnyDate': 'कोई भी तारीख चुनें',
    'book.swipeDays': 'और दिन देखने के लिए स्वाइप करें, या किसी और दिन के लिए ऊपर तारीख पर टैप करें।',
    'book.moveReasonHead': 'समय बदलने का कारण',
    'book.currently': 'अभी {time}, {code}',
    'book.whyMoved': 'समय क्यों बदला जा रहा है?',
    'book.whyMovedPh': 'डॉक्टर को बाहर जाना पड़ा, मरीज़ का अनुरोध…',
    'book.oldStays': 'पुरानी बुकिंग रिकॉर्ड में "समय बदला" के रूप में रहेगी।',
    'book.yourAppointment': 'आपकी अपॉइंटमेंट',
    'book.notLinked': 'आपका लॉगिन अभी किसी मरीज़ रिकॉर्ड से नहीं जुड़ा है, इसलिए बुकिंग नहीं हो सकती। कृपया क्लिनिक से इसे जोड़ने के लिए कहें।',
    'book.change': 'बदलें',
    'book.addPatient': 'नया मरीज़ जोड़ें',
    'book.recent': 'हाल ही में जोड़े या बदले गए',
    'book.searchHint': 'मरीज़ चुनने के लिए नाम, मोबाइल या मरीज़ कोड से खोजें।',
    'book.selectTime': 'समय चुनें',
    'book.legendFree': 'खाली',
    'book.legendChosen': 'चुना गया',
    'book.legendBooked': 'बुक',
    'book.legendPassed': 'निकल गया',
    'book.loadingSlots': 'स्लॉट लोड हो रहे हैं…',
    'book.closedReason': 'बंद - {reason}। कोई और दिन चुनें।',
    'book.closed': 'बंद है। कोई और दिन चुनें।',
    'book.noSessionsDay': 'डॉक्टर इस दिन मरीज़ नहीं देखते।',
    'book.slot.booked': 'बुक है',
    'book.slot.held': 'भुगतान चल रहा है',
    'book.slot.past': 'समय निकल गया',
    'book.followUpRate': 'फ़ॉलो-अप फ़ीस, {fee} की जगह।',
    'book.followUpFee': 'फ़ॉलो-अप फ़ीस',
    'book.payNowQr': 'स्लॉट पक्का करने के लिए {amount} का भुगतान QR स्कैन करके होगा।',
    'book.payNowUpi': 'स्लॉट पक्का करने के लिए {amount} का भुगतान UPI से होगा।',
    'book.payCash': 'काउंटर पर नकद भुगतान। रसीद वहीं बनेगी।',
    'book.payMethod': 'भुगतान का तरीका',
    'book.holdNote': 'भुगतान करते समय स्लॉट कुछ मिनट के लिए आपके लिए रोका जाता है, और भुगतान पक्का होते ही बुक हो जाता है।',
    'book.override': 'फिर भी बुक करें (ओवरराइड)',
    'book.overrideReason': 'ओवरराइड का कारण',
    'book.overridePh': 'वॉक-इन मरीज़ पहले देखा गया, डॉक्टर देर तक रुकने को तैयार…',
    'book.overrideHint': 'यह आपके नाम के साथ बुकिंग में दर्ज होगा।',
    'book.confirmMoveHead': 'समय बदलना पक्का करें',
    'book.confirmBookingHead': 'अपनी बुकिंग पक्की करें',
    'book.paidNow': '{method} — अभी भुगतान',
    'book.booking': 'बुक हो रहा है…',
    'book.confirmMoveBtn': 'समय बदलें',
    'book.confirmBookingBtn': 'बुकिंग पक्की करें',

    'book.qrFailed': 'QR नहीं बन सका। कृपया भुगतान का कोई और तरीका चुनें।',
    'book.scanToPayAlt': 'भुगतान के लिए स्कैन करें',
    'book.slotHeldUntil': 'भुगतान करने तक आपका स्लॉट {time} तक आपके लिए रोका गया है।',
    'book.errStartPayment': 'भुगतान शुरू नहीं हो सका।',
    'book.errNotThrough': 'भुगतान नहीं हो पाया।',
    'book.notSeenYet': 'हमें अभी तक भुगतान नहीं दिखा है। अगर आपके खाते से पैसे कट गए हैं तो वह जल्द ही दिख जाएगा।',
    'book.errQr': 'QR कोड नहीं बन सका।',
    'book.errSim': 'टेस्ट भुगतान नहीं हो पाया।',
    'book.openingPayment': 'सुरक्षित भुगतान खुल रहा है…',
    'book.payAmount': '{amount} का भुगतान करें',
    'book.testMode': 'टेस्ट मोड — कोई पैसा नहीं कटेगा। चुनें कि बैंक क्या जवाब दे।',
    'book.approve': 'मंज़ूर · {mode}',
    'book.decline': 'अस्वीकार',
    'book.scanQr': 'QR स्कैन करें',
    'book.redirect': 'भुगतान के लिए आपको {provider} पर ले जाया जाएगा। क्लिनिक आपके कार्ड या UPI की जानकारी कभी नहीं देखता।',
    'book.notNow': 'अभी नहीं',
    'book.payByQrInstead': 'इसके बजाय QR स्कैन करके भुगतान करें',
    'book.scanToPay': '{amount} के भुगतान के लिए स्कैन करें',
    'book.openUpiApp': 'कोई भी UPI ऐप खोलें — GPay, PhonePe, Paytm या अपने बैंक का ऐप — और इसे स्कैन करें।',
    'book.waitingPayment': 'भुगतान का इंतज़ार है…',
    'book.simulateScan': 'टेस्ट स्कैन करें',
    'book.confirmingPayment': 'आपका भुगतान पक्का हो रहा है…',
    'book.dontClose': 'कृपया यह स्क्रीन बंद न करें और दोबारा भुगतान न करें।',
    'book.paidTitle': 'भुगतान मिल गया',
    'book.paidLine': '{amount} का भुगतान हो गया — {title}।',
    'book.receiptNo': 'रसीद {no}',
    'book.notCompleted': 'भुगतान पूरा नहीं हुआ',
    'book.somethingWrong': 'कुछ गड़बड़ हो गई।',
    'book.failedDraft': 'कोई पैसा नहीं कटा है और स्लॉट बुक नहीं हुआ है। फिर से कोशिश करें, या वापस जाकर क्लिनिक पर भुगतान चुनें।',
    'book.failedHeld': 'आपकी बुकिंग अभी भी रुकी हुई है। आप फिर से कोशिश कर सकते हैं, या क्लिनिक पर भुगतान कर सकते हैं।',

    'book.errRecord': 'भुगतान दर्ज नहीं हो सका।',
    'book.recording': 'भुगतान दर्ज हो रहा है…',
    'book.recordTitle': '{amount} मिलना दर्ज करें',
    'book.recordWarn': 'यह केवल वह पैसा दर्ज करता है जो क्लिनिक को पहले ही मिल चुका है। इससे किसी से पैसा नहीं कटता।',
    'book.txnNo': 'ट्रांज़ैक्शन नंबर',
    'book.txnPh': 'UTR, चेक नंबर, UPI रेफ़रेंस',
    'book.txnHint': 'बैंक या ऐप इसे जो भी कहे — बैंक स्टेटमेंट से इसी का मिलान होता है।',
    'book.attachment': 'अटैचमेंट (वैकल्पिक)',
    'book.attachHint': 'अगर हो तो स्क्रीनशॉट, रसीद या स्कैन लगाएँ। PDF या फ़ोटो, {mb} MB तक।',
    'book.fileTooBig': 'यह फ़ाइल {mb} MB से बड़ी है।',
    'book.noteOptional': 'नोट (वैकल्पिक)',
    'book.notePh': 'नियोक्ता ने भुगतान किया, चेक शुक्रवार को क्लियर होगा…',
    'book.recordPayment': 'भुगतान दर्ज करें',
    'book.enterTxnFirst': 'सेव करने से पहले ट्रांज़ैक्शन नंबर भरें।',

    'book.chooseDoctor': 'डॉक्टर चुनें',
    'book.filters': 'फ़िल्टर',
    'book.searchDoctors': 'डॉक्टर खोजें',
    'book.searchDoctorsPh': 'नाम या विशेषज्ञता से खोजें',
    'book.specialties': 'विशेषज्ञता',
    'book.filterDoctors': 'डॉक्टर फ़िल्टर करें',
    'book.specialty': 'विशेषज्ञता',
    'book.any': 'कोई भी',
    'book.feeUpTo': 'परामर्श फ़ीस (अधिकतम)',
    'book.nobodyQueued': 'आज अभी कोई कतार में नहीं',
    'book.orderBy': 'क्रम',
    'book.sortRoster': 'सूची के अनुसार',
    'book.sortLoad': 'सबसे कम मरीज़',
    'book.clear': 'साफ़ करें',
    'book.showN': '{n} दिखाएँ',
    'book.noDoctorMatch': 'कोई डॉक्टर नहीं मिला',
    'book.tryDifferent': 'कोई और नाम या विशेषज्ञता आज़माएँ।',
    'book.viewProfile': 'प्रोफ़ाइल देखें — {name}',
    'book.todayCount': 'आज {n}',
    'book.perConsultation': '/परामर्श',
    'book.book': 'बुक करें',
    'book.bio': '{name} क्लिनिक में {spec} परामर्श देते हैं। बुक करने से पहले उपलब्धता और फ़ॉलो-अप के बारे में पूछ लें।',

    'book.recentChanges': 'हाल के बदलाव',
    'book.onYourBehalf': 'आपकी ओर से',
    'book.errLoadBookings': 'बुकिंग लोड नहीं हो सकीं।',
    'book.searchBooked': 'बुक किए गए मरीज़ खोजें',
    'book.searchBookedPh': 'मरीज़ का नाम, कोड या मोबाइल',
    'book.filterStatus': 'स्थिति से फ़िल्टर करें',
    'book.bucketDone': 'पूरी',
    'book.filterPayment': 'भुगतान से फ़िल्टर करें',
    'book.loadingBookings': 'बुकिंग लोड हो रही हैं…',
    'book.nobodyBookedOn': '{date} को कोई बुकिंग नहीं',
    'book.nobodyMatches': 'इन फ़िल्टर से कोई नहीं मिला',
    'book.useArrows': 'दूसरा दिन देखने के लिए तीर का उपयोग करें।',
    'book.clearSearch': 'खोज साफ़ करें या कोई और फ़िल्टर चुनें।',
    'book.amountPaid': '{amount} भुगतान हो गया',
    'book.amountDue': '{amount} बाकी',
    'book.doctorNotFound': 'डॉक्टर नहीं मिले।',
    'book.bookNow': 'अभी बुक करें',
    'book.doctorProfile': 'डॉक्टर की प्रोफ़ाइल',
    'book.perVisit': '/विज़िट',
    'book.message': 'संदेश भेजें',
    'book.onFile': 'रिकॉर्ड में है',
    'book.qualifications': 'योग्यता',
    'book.notListed': 'दर्ज नहीं',
    'book.registration': 'रजिस्ट्रेशन',
    'book.inQueueToday': 'आज कतार में',
    'book.tabAbout': 'परिचय',
    'book.tabBooked': 'बुकिंग',
    'book.tabAvailability': 'उपलब्धता',
    'book.tabReviews': 'समीक्षाएँ',
    'book.aboutDoctor': 'डॉक्टर के बारे में',
    'book.seeMore': 'और देखें…',
    'book.credentials': 'योग्यता और पंजीकरण',
    'book.regNo': 'रजि. नं.',
    'book.missing': 'दर्ज नहीं',
    'book.consultation': 'परामर्श',
    'book.followUpTerms_one': '{fee} · {n} दिन के अंदर',
    'book.followUpTerms_other': '{fee} · {n} दिन के अंदर',
    'book.phone': 'फ़ोन',
    'book.clinic': 'क्लिनिक',
    'book.reviewsHead': 'समीक्षाएँ और रेटिंग',
    'book.patientFeedback': 'मरीज़ों की राय',
    'book.reviewsNA': 'समीक्षाएँ अभी उपलब्ध नहीं हैं',
    'book.reviewsNABody': 'क्लिनिक जब मरीज़ों की राय लेना शुरू करेगा, तब वह यहाँ दिखेगी।',
    'book.todaySessions': 'आज के सत्र',
    'book.closedTodayReason': 'आज बंद है — {reason}।',
    'book.closedToday': 'आज बंद है।',
    'book.noSessionsToday': 'आज के लिए कोई सत्र तय नहीं है।',
    'book.sessionBooked': '{count} बुक',
    'book.inTheQueue': 'कतार में',
    'book.yourList': 'आपकी सूची',
    'book.openConsult': 'परामर्श कक्ष खोलें',
    'book.manageAvailability': 'उपलब्धता संभालें',
    'book.yourHours': 'आपका समय',
    'book.onBehalfOf': '{name} की ओर से',
    'book.onlyCanChange': 'यह समय केवल {name}, रिसेप्शन या एडमिनिस्ट्रेटर बदल सकते हैं।',
  },
  mr: {
    'book.confirmedPill': 'निश्चित',
    'book.consultingDoctor': 'सल्लागार डॉक्टर',
    'book.dateTime': 'तारीख आणि वेळ',
    'book.continuePay': 'पेमेंटकडे पुढे जा',
    'book.bookingFor': 'रुग्णासाठी बुकिंग',
    'book.availableToday': 'आज उपलब्ध',
    'book.consultFee': 'सल्ला शुल्क',
    'book.viewMonth': 'महिना पहा',
    'book.today': 'आज',
    'book.slotsN': '{n} स्लॉट',
    'book.slotsOne': '1 स्लॉट',
    'book.full': 'भरलेले',
    'book.closedShort': 'बंद',
    'book.availableN': '{n} उपलब्ध',
    'book.availableParen': '({n} उपलब्ध)',
    'book.feeValue': 'शुल्क: {amount}',
    'book.summarySlot': 'स्लॉट सारांश',
    'book.summaryFee': 'देय',
    'book.title': 'बुक करा',
    'book.titleBook': 'अपॉइंटमेंट बुक करा',
    'book.titleMove': 'अपॉइंटमेंटची वेळ बदला',
    'book.titleBooked': 'बुक झाली',
    'book.payment': 'पेमेंट',
    'book.payChoice.cash': 'क्लिनिकमध्ये रोख',
    'book.payChoice.upi': 'UPI',
    'book.payChoice.qr': 'QR कोड स्कॅन करा',
    'book.errLoadDay': 'या दिवसाची माहिती लोड होऊ शकली नाही.',
    'book.errSearch': 'आत्ता शोध घेता आला नाही.',
    'book.timePassed': 'ही वेळ निघून गेली आहे. कृपया नंतरचा स्लॉट निवडा.',
    'book.overrideReasonNeeded': 'ठरलेल्या वेळेबाहेर बुक करण्याचे कारण लिहा.',
    'book.theAppointment': 'अपॉइंटमेंट',
    'book.errBook': 'बुकिंग होऊ शकले नाही.',
    'book.alreadyCheckedIn': 'या डॉक्टरांकडे आजची भेट आधीच आहे — टोकन #{token}.',
    'book.checkedIn': 'चेक-इन झाले — टोकन #{token}. आता व्हायटल्स नोंदवा.',
    'book.errCheckIn': 'रुग्णाचे चेक-इन होऊ शकले नाही.',
    'book.waitMoving': 'तुमच्या अपॉइंटमेंटची\nवेळ बदलत आहोत…',
    'book.waitBooking': 'तुमची अपॉइंटमेंट\nबुक करत आहोत…',
    'book.waitFewSeconds': 'याला काही सेकंदच लागतील',
    'book.clinicFallback': 'क्लिनिक',
    'book.checkingIn': 'चेक-इन होत आहे…',
    'book.checkInVitals': 'चेक-इन करा आणि व्हायटल्स नोंदवा',
    'book.shareTicketWhatsApp': 'WhatsApp वर तिकीट पाठवा',
    'book.payAmountNow': 'आत्ता {amount} भरा',
    'book.viewBooking': 'बुकिंग पाहा',
    'book.viewBookings': 'बुकिंग पाहा',
    'book.backHome': 'होमवर परत जा',
    'book.movedDone': 'अपॉइंटमेंटची वेळ बदलली!',
    'book.bookedDone': 'अपॉइंटमेंट बुक झाली!',
    'book.withDoctor': '{doctor} यांच्याकडे',
    'book.dateAtTime': '{date}, {time} वाजता',
    'book.dateAtTimePast': '{date}, {time} वाजता (वेळ निघून गेली)',
    'book.bookingRef': 'बुकिंग {ref}',
    'book.dueNowOrClinic': '{amount} बाकी — आत्ता भरा किंवा क्लिनिकमध्ये.',
    'book.consultWith': '{doctor} यांच्याशी सल्लामसलत',
    'book.paymentReceived': 'पेमेंट मिळाले.',
    'book.paidSlotConfirmed': 'पेमेंट मिळाले. तुमचा स्लॉट निश्चित झाला आहे.',
    'book.pickTime': 'वेळ निवडा',
    'book.giveReason': 'कारण लिहा',
    'book.accountNotLinked': 'खाते जोडलेले नाही',
    'book.pickPatient': 'रुग्ण निवडा',
    'book.cannotBookDoctor': 'या डॉक्टरांकडे बुक करता येत नाही',
    'book.loadingFee': 'फी लोड होत आहे…',
    'book.ctaReviewMove': 'नवी वेळ तपासा: {time}, {date}',
    'book.ctaContinuePay': 'पेमेंटकडे चला · {time}, {date}',
    'book.ctaConfirmPay': 'निश्चित करा आणि {amount} भरा',
    'book.ctaConfirmCash': 'निश्चित करा · {amount} काउंटरवर रोख',
    'book.generalPractice': 'सामान्य उपचार',
    'book.selectDate': 'तारीख निवडा',
    'book.pickAnyDate': 'कोणतीही तारीख निवडा',
    'book.swipeDays': 'आणखी दिवस पाहण्यासाठी स्वाइप करा, किंवा इतर दिवसासाठी वरच्या तारखेवर टॅप करा.',
    'book.moveReasonHead': 'वेळ बदलण्याचे कारण',
    'book.currently': 'सध्या {time}, {code}',
    'book.whyMoved': 'वेळ का बदलत आहात?',
    'book.whyMovedPh': 'डॉक्टरांना बाहेर जावे लागले, रुग्णाची विनंती…',
    'book.oldStays': 'जुने बुकिंग रेकॉर्डमध्ये "वेळ बदलली" म्हणून राहील.',
    'book.yourAppointment': 'तुमची अपॉइंटमेंट',
    'book.notLinked': 'तुमचे लॉगिन अजून कोणत्याही रुग्ण रेकॉर्डशी जोडलेले नाही, त्यामुळे बुकिंग करता येत नाही. कृपया क्लिनिकला ते जोडायला सांगा.',
    'book.change': 'बदला',
    'book.addPatient': 'नवीन रुग्ण जोडा',
    'book.recent': 'नुकतेच जोडलेले किंवा बदललेले',
    'book.searchHint': 'रुग्ण निवडण्यासाठी नाव, मोबाइल किंवा रुग्ण कोडने शोधा.',
    'book.selectTime': 'वेळ निवडा',
    'book.legendFree': 'रिकामी',
    'book.legendChosen': 'निवडलेली',
    'book.legendBooked': 'बुक',
    'book.legendPassed': 'गेलेली',
    'book.loadingSlots': 'स्लॉट लोड होत आहेत…',
    'book.closedReason': 'बंद - {reason}. दुसरा दिवस निवडा.',
    'book.closed': 'बंद आहे. दुसरा दिवस निवडा.',
    'book.noSessionsDay': 'या दिवशी डॉक्टर रुग्ण पाहत नाहीत.',
    'book.slot.booked': 'बुक आहे',
    'book.slot.held': 'पेमेंट सुरू आहे',
    'book.slot.past': 'वेळ गेली',
    'book.followUpRate': 'फॉलो-अप फी, {fee} ऐवजी.',
    'book.followUpFee': 'फॉलो-अप फी',
    'book.payNowQr': 'स्लॉट निश्चित करण्यासाठी {amount} QR स्कॅन करून भरायचे आहेत.',
    'book.payNowUpi': 'स्लॉट निश्चित करण्यासाठी {amount} UPI ने भरायचे आहेत.',
    'book.payCash': 'काउंटरवर रोख भरायचे. पावती तिथेच मिळेल.',
    'book.payMethod': 'पेमेंटची पद्धत',
    'book.holdNote': 'तुम्ही पैसे भरेपर्यंत स्लॉट काही मिनिटे तुमच्यासाठी राखून ठेवला जातो, आणि पेमेंट निश्चित होताच बुक होतो.',
    'book.override': 'तरीही बुक करा (ओव्हरराइड)',
    'book.overrideReason': 'ओव्हरराइडचे कारण',
    'book.overridePh': 'वॉक-इन रुग्ण आधी पाहिला, डॉक्टर उशिरापर्यंत थांबायला तयार…',
    'book.overrideHint': 'हे तुमच्या नावासह बुकिंगमध्ये नोंदवले जाईल.',
    'book.confirmMoveHead': 'वेळ बदलणे निश्चित करा',
    'book.confirmBookingHead': 'तुमचे बुकिंग निश्चित करा',
    'book.paidNow': '{method} — आत्ता भरायचे',
    'book.booking': 'बुक होत आहे…',
    'book.confirmMoveBtn': 'वेळ बदला',
    'book.confirmBookingBtn': 'बुकिंग निश्चित करा',

    'book.qrFailed': 'QR तयार होऊ शकला नाही. कृपया पेमेंटची दुसरी पद्धत वापरा.',
    'book.scanToPayAlt': 'पैसे भरण्यासाठी स्कॅन करा',
    'book.slotHeldUntil': 'तुम्ही पैसे भरेपर्यंत तुमचा स्लॉट {time} पर्यंत राखून ठेवला आहे.',
    'book.errStartPayment': 'पेमेंट सुरू होऊ शकले नाही.',
    'book.errNotThrough': 'पेमेंट झाले नाही.',
    'book.notSeenYet': 'आम्हाला अजून पेमेंट दिसलेले नाही. तुमच्या खात्यातून पैसे गेले असतील तर ते लवकरच दिसेल.',
    'book.errQr': 'QR कोड तयार होऊ शकला नाही.',
    'book.errSim': 'टेस्ट पेमेंट झाले नाही.',
    'book.openingPayment': 'सुरक्षित पेमेंट उघडत आहे…',
    'book.payAmount': '{amount} भरा',
    'book.testMode': 'टेस्ट मोड — कोणतेही पैसे जाणार नाहीत. बँकेने काय उत्तर द्यावे ते निवडा.',
    'book.approve': 'मंजूर · {mode}',
    'book.decline': 'नाकारा',
    'book.scanQr': 'QR स्कॅन करा',
    'book.redirect': 'पैसे भरण्यासाठी तुम्हाला {provider} वर नेले जाईल. क्लिनिकला तुमच्या कार्डची किंवा UPI ची माहिती कधीच दिसत नाही.',
    'book.notNow': 'आत्ता नको',
    'book.payByQrInstead': 'त्याऐवजी QR स्कॅन करून भरा',
    'book.scanToPay': '{amount} भरण्यासाठी स्कॅन करा',
    'book.openUpiApp': 'कोणतेही UPI ॲप उघडा — GPay, PhonePe, Paytm किंवा तुमच्या बँकेचे ॲप — आणि हे स्कॅन करा.',
    'book.waitingPayment': 'पेमेंटची वाट पाहत आहोत…',
    'book.simulateScan': 'टेस्ट स्कॅन करा',
    'book.confirmingPayment': 'तुमचे पेमेंट निश्चित करत आहोत…',
    'book.dontClose': 'कृपया ही स्क्रीन बंद करू नका आणि पुन्हा पैसे भरू नका.',
    'book.paidTitle': 'पेमेंट मिळाले',
    'book.paidLine': '{amount} भरले — {title}.',
    'book.receiptNo': 'पावती {no}',
    'book.notCompleted': 'पेमेंट पूर्ण झाले नाही',
    'book.somethingWrong': 'काहीतरी चूक झाली.',
    'book.failedDraft': 'कोणतेही पैसे कापले गेले नाहीत आणि स्लॉट बुक झालेला नाही. पुन्हा प्रयत्न करा, किंवा मागे जाऊन क्लिनिकमध्ये पैसे भरणे निवडा.',
    'book.failedHeld': 'तुमचे बुकिंग अजूनही राखून ठेवलेले आहे. तुम्ही पुन्हा प्रयत्न करू शकता, किंवा क्लिनिकमध्ये पैसे भरू शकता.',

    'book.errRecord': 'पेमेंट नोंदवता आले नाही.',
    'book.recording': 'पेमेंट नोंदवत आहोत…',
    'book.recordTitle': '{amount} मिळाल्याची नोंद करा',
    'book.recordWarn': 'हे फक्त क्लिनिकला आधीच मिळालेल्या पैशांची नोंद करते. यामुळे कोणाकडूनही पैसे घेतले जात नाहीत.',
    'book.txnNo': 'व्यवहार क्रमांक',
    'book.txnPh': 'UTR, चेक नंबर, UPI रेफरन्स',
    'book.txnHint': 'बँक किंवा ॲप याला काहीही म्हणो — बँक स्टेटमेंटशी याचाच ताळमेळ घातला जातो.',
    'book.attachment': 'अटॅचमेंट (ऐच्छिक)',
    'book.attachHint': 'असल्यास स्क्रीनशॉट, पावती किंवा स्कॅन जोडा. PDF किंवा फोटो, {mb} MB पर्यंत.',
    'book.fileTooBig': 'ही फाइल {mb} MB पेक्षा मोठी आहे.',
    'book.noteOptional': 'नोंद (ऐच्छिक)',
    'book.notePh': 'मालकाने पैसे भरले, चेक शुक्रवारी क्लिअर होईल…',
    'book.recordPayment': 'पेमेंट नोंदवा',
    'book.enterTxnFirst': 'सेव्ह करण्यापूर्वी व्यवहार क्रमांक भरा.',

    'book.chooseDoctor': 'डॉक्टर निवडा',
    'book.filters': 'फिल्टर',
    'book.searchDoctors': 'डॉक्टर शोधा',
    'book.searchDoctorsPh': 'नाव किंवा स्पेशालिटीने शोधा',
    'book.specialties': 'स्पेशालिटी',
    'book.filterDoctors': 'डॉक्टर फिल्टर करा',
    'book.specialty': 'स्पेशालिटी',
    'book.any': 'कोणतीही',
    'book.feeUpTo': 'सल्लामसलत फी (जास्तीत जास्त)',
    'book.nobodyQueued': 'आज अजून रांगेत कोणी नाही',
    'book.orderBy': 'क्रम',
    'book.sortRoster': 'यादीनुसार',
    'book.sortLoad': 'सर्वात कमी रुग्ण',
    'book.clear': 'साफ करा',
    'book.showN': '{n} दाखवा',
    'book.noDoctorMatch': 'कोणतेही डॉक्टर सापडले नाहीत',
    'book.tryDifferent': 'दुसरे नाव किंवा स्पेशालिटी वापरून पाहा.',
    'book.viewProfile': 'प्रोफाइल पाहा — {name}',
    'book.todayCount': 'आज {n}',
    'book.perConsultation': '/सल्लामसलत',
    'book.book': 'बुक करा',
    'book.bio': '{name} क्लिनिकमध्ये {spec} सल्लामसलत देतात. बुक करण्यापूर्वी उपलब्धता आणि फॉलो-अपबद्दल विचारून घ्या.',

    'book.recentChanges': 'अलीकडील बदल',
    'book.onYourBehalf': 'तुमच्या वतीने',
    'book.errLoadBookings': 'बुकिंग लोड होऊ शकली नाहीत.',
    'book.searchBooked': 'बुक केलेले रुग्ण शोधा',
    'book.searchBookedPh': 'रुग्णाचे नाव, कोड किंवा मोबाइल',
    'book.filterStatus': 'स्थितीनुसार फिल्टर करा',
    'book.bucketDone': 'पूर्ण',
    'book.filterPayment': 'पेमेंटनुसार फिल्टर करा',
    'book.loadingBookings': 'बुकिंग लोड होत आहेत…',
    'book.nobodyBookedOn': '{date} रोजी कोणतेही बुकिंग नाही',
    'book.nobodyMatches': 'या फिल्टरनुसार कोणी सापडले नाही',
    'book.useArrows': 'दुसरा दिवस पाहण्यासाठी बाण वापरा.',
    'book.clearSearch': 'शोध साफ करा किंवा दुसरा फिल्टर निवडा.',
    'book.amountPaid': '{amount} भरले',
    'book.amountDue': '{amount} बाकी',
    'book.doctorNotFound': 'डॉक्टर सापडले नाहीत.',
    'book.bookNow': 'आत्ता बुक करा',
    'book.doctorProfile': 'डॉक्टरांची प्रोफाइल',
    'book.perVisit': '/भेट',
    'book.message': 'संदेश पाठवा',
    'book.onFile': 'रेकॉर्डमध्ये आहे',
    'book.qualifications': 'पात्रता',
    'book.notListed': 'नोंद नाही',
    'book.registration': 'नोंदणी',
    'book.inQueueToday': 'आज रांगेत',
    'book.tabAbout': 'माहिती',
    'book.tabBooked': 'बुकिंग',
    'book.tabAvailability': 'उपलब्धता',
    'book.tabReviews': 'अभिप्राय',
    'book.aboutDoctor': 'डॉक्टरांबद्दल',
    'book.seeMore': 'आणखी पाहा…',
    'book.credentials': 'पात्रता आणि नोंदणी',
    'book.regNo': 'नोंदणी क्र.',
    'book.missing': 'नोंद नाही',
    'book.consultation': 'सल्लामसलत',
    'book.followUpTerms_one': '{fee} · {n} दिवसाच्या आत',
    'book.followUpTerms_other': '{fee} · {n} दिवसांच्या आत',
    'book.phone': 'फोन',
    'book.clinic': 'क्लिनिक',
    'book.reviewsHead': 'अभिप्राय आणि रेटिंग',
    'book.patientFeedback': 'रुग्णांचे अभिप्राय',
    'book.reviewsNA': 'अभिप्राय अजून उपलब्ध नाहीत',
    'book.reviewsNABody': 'क्लिनिकने रुग्णांचे अभिप्राय घ्यायला सुरुवात केल्यावर ते इथे दिसतील.',
    'book.todaySessions': 'आजची सत्रे',
    'book.closedTodayReason': 'आज बंद — {reason}.',
    'book.closedToday': 'आज बंद.',
    'book.noSessionsToday': 'आजसाठी कोणतेही सत्र ठरलेले नाही.',
    'book.sessionBooked': '{count} बुक',
    'book.inTheQueue': 'रांगेत',
    'book.yourList': 'तुमची यादी',
    'book.openConsult': 'कन्सल्टिंग रूम उघडा',
    'book.manageAvailability': 'उपलब्धता व्यवस्थापित करा',
    'book.yourHours': 'तुमच्या वेळा',
    'book.onBehalfOf': '{name} यांच्या वतीने',
    'book.onlyCanChange': 'या वेळा फक्त {name}, रिसेप्शन किंवा ॲडमिनिस्ट्रेटर बदलू शकतात.',
  },
  or: {
    'book.confirmedPill': 'ନିଶ୍ଚିତ',
    'book.consultingDoctor': 'ପରାମର୍ଶ ଡାକ୍ତର',
    'book.dateTime': 'ତାରିଖ ଓ ସମୟ',
    'book.continuePay': 'ପେମେଣ୍ଟକୁ ଆଗକୁ ଯାଆନ୍ତୁ',
    'book.bookingFor': 'ରୋଗୀଙ୍କ ପାଇଁ ବୁକିଂ',
    'book.availableToday': 'ଆଜି ଉପଲବ୍ଧ',
    'book.consultFee': 'ପରାମର୍ଶ ଫି',
    'book.viewMonth': 'ମାସ ଦେଖନ୍ତୁ',
    'book.today': 'ଆଜି',
    'book.slotsN': '{n} ସ୍ଲଟ୍',
    'book.slotsOne': '1 ସ୍ଲଟ୍',
    'book.full': 'ପୂର୍ଣ୍ଣ',
    'book.closedShort': 'ବନ୍ଦ',
    'book.availableN': '{n} ଉପଲବ୍ଧ',
    'book.availableParen': '({n} ଉପଲବ୍ଧ)',
    'book.feeValue': 'ଫି: {amount}',
    'book.summarySlot': 'ସ୍ଲଟ୍ ସାରାଂଶ',
    'book.summaryFee': 'ଦେୟ',
    'book.title': 'ବୁକ୍ କରନ୍ତୁ',
    'book.titleBook': 'ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ୍ କରନ୍ତୁ',
    'book.titleMove': 'ଆପଏଣ୍ଟମେଣ୍ଟ ସମୟ ବଦଳାନ୍ତୁ',
    'book.titleBooked': 'ବୁକ୍ ହୋଇଗଲା',
    'book.payment': 'ଦେୟ',
    'book.payChoice.cash': 'କ୍ଲିନିକରେ ନଗଦ',
    'book.payChoice.upi': 'UPI',
    'book.payChoice.qr': 'QR କୋଡ୍ ସ୍କାନ୍ କରନ୍ତୁ',
    'book.errLoadDay': 'ଏହି ଦିନର ସୂଚନା ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'book.errSearch': 'ବର୍ତ୍ତମାନ ଖୋଜି ହେଲା ନାହିଁ।',
    'book.timePassed': 'ଏହି ସମୟ ଚାଲିଗଲାଣି। ଦୟାକରି ପରବର୍ତ୍ତୀ ସ୍ଲଟ୍ ବାଛନ୍ତୁ।',
    'book.overrideReasonNeeded': 'ନିର୍ଦ୍ଧାରିତ ସମୟ ବାହାରେ ବୁକ୍ କରିବାର କାରଣ ଲେଖନ୍ତୁ।',
    'book.theAppointment': 'ଆପଏଣ୍ଟମେଣ୍ଟ',
    'book.errBook': 'ବୁକ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'book.alreadyCheckedIn': 'ଏହି ଡାକ୍ତରଙ୍କ ସହ ଆଜିର ପରିଦର୍ଶନ ପୂର୍ବରୁ ଅଛି — ଟୋକେନ୍ #{token}।',
    'book.checkedIn': 'ଚେକ୍-ଇନ୍ ହୋଇଗଲା — ଟୋକେନ୍ #{token}। ଏବେ ଭାଇଟାଲ୍ସ ଲେଖନ୍ତୁ।',
    'book.errCheckIn': 'ରୋଗୀଙ୍କ ଚେକ୍-ଇନ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'book.waitMoving': 'ଆପଣଙ୍କ ଆପଏଣ୍ଟମେଣ୍ଟର\nସମୟ ବଦଳାଯାଉଛି…',
    'book.waitBooking': 'ଆପଣଙ୍କ ଆପଏଣ୍ଟମେଣ୍ଟ\nବୁକ୍ ହେଉଛି…',
    'book.waitFewSeconds': 'ଏଥିରେ କିଛି ସେକେଣ୍ଡ ଲାଗିବ',
    'book.clinicFallback': 'କ୍ଲିନିକ୍',
    'book.checkingIn': 'ଚେକ୍-ଇନ୍ ହେଉଛି…',
    'book.checkInVitals': 'ଚେକ୍-ଇନ୍ କରି ଭାଇଟାଲ୍ସ ଲେଖନ୍ତୁ',
    'book.shareTicketWhatsApp': 'WhatsApp ରେ ଟିକେଟ୍ ପଠାନ୍ତୁ',
    'book.payAmountNow': 'ଏବେ {amount} ଦିଅନ୍ତୁ',
    'book.viewBooking': 'ବୁକିଂ ଦେଖନ୍ତୁ',
    'book.viewBookings': 'ବୁକିଂ ଦେଖନ୍ତୁ',
    'book.backHome': 'ହୋମ୍‌କୁ ଫେରନ୍ତୁ',
    'book.movedDone': 'ଆପଏଣ୍ଟମେଣ୍ଟ ସମୟ ବଦଳିଗଲା!',
    'book.bookedDone': 'ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ୍ ହୋଇଗଲା!',
    'book.withDoctor': '{doctor} ଙ୍କ ସହ',
    'book.dateAtTime': '{date}, {time} ରେ',
    'book.dateAtTimePast': '{date}, {time} ରେ (ସମୟ ଚାଲିଗଲାଣି)',
    'book.bookingRef': 'ବୁକିଂ {ref}',
    'book.dueNowOrClinic': '{amount} ବାକି — ଏବେ କିମ୍ବା କ୍ଲିନିକରେ ଦିଅନ୍ତୁ।',
    'book.consultWith': '{doctor} ଙ୍କ ସହ ପରାମର୍ଶ',
    'book.paymentReceived': 'ଦେୟ ମିଳିଗଲା।',
    'book.paidSlotConfirmed': 'ଦେୟ ମିଳିଗଲା। ଆପଣଙ୍କ ସ୍ଲଟ୍ ନିଶ୍ଚିତ ହୋଇଗଲା।',
    'book.pickTime': 'ସମୟ ବାଛନ୍ତୁ',
    'book.giveReason': 'କାରଣ ଲେଖନ୍ତୁ',
    'book.accountNotLinked': 'ଆକାଉଣ୍ଟ ଯୋଡ଼ା ହୋଇନାହିଁ',
    'book.pickPatient': 'ରୋଗୀ ବାଛନ୍ତୁ',
    'book.cannotBookDoctor': 'ଏହି ଡାକ୍ତରଙ୍କ ପାଇଁ ବୁକ୍ କରିହେବ ନାହିଁ',
    'book.loadingFee': 'ଫି ଲୋଡ୍ ହେଉଛି…',
    'book.ctaReviewMove': 'ନୂଆ ସମୟ ଯାଞ୍ଚ କରନ୍ତୁ: {time}, {date}',
    'book.ctaContinuePay': 'ଦେୟକୁ ଯାଆନ୍ତୁ · {time}, {date}',
    'book.ctaConfirmPay': 'ନିଶ୍ଚିତ କରି {amount} ଦିଅନ୍ତୁ',
    'book.ctaConfirmCash': 'ନିଶ୍ଚିତ କରନ୍ତୁ · {amount} କାଉଣ୍ଟରରେ ନଗଦ',
    'book.generalPractice': 'ସାଧାରଣ ଚିକିତ୍ସା',
    'book.selectDate': 'ତାରିଖ ବାଛନ୍ତୁ',
    'book.pickAnyDate': 'ଯେକୌଣସି ତାରିଖ ବାଛନ୍ତୁ',
    'book.swipeDays': 'ଅଧିକ ଦିନ ପାଇଁ ସ୍ୱାଇପ୍ କରନ୍ତୁ, କିମ୍ବା ଅନ୍ୟ ଦିନ ପାଇଁ ଉପରେ ଥିବା ତାରିଖରେ ଟାପ୍ କରନ୍ତୁ।',
    'book.moveReasonHead': 'ସମୟ ବଦଳାଇବାର କାରଣ',
    'book.currently': 'ବର୍ତ୍ତମାନ {time}, {code}',
    'book.whyMoved': 'ସମୟ କାହିଁକି ବଦଳାଯାଉଛି?',
    'book.whyMovedPh': 'ଡାକ୍ତରଙ୍କୁ ବାହାରକୁ ଯିବାକୁ ପଡ଼ିଲା, ରୋଗୀଙ୍କ ଅନୁରୋଧ…',
    'book.oldStays': 'ପୁରୁଣା ବୁକିଂ ରେକର୍ଡରେ "ସମୟ ବଦଳିଛି" ଭାବେ ରହିବ।',
    'book.yourAppointment': 'ଆପଣଙ୍କ ଆପଏଣ୍ଟମେଣ୍ଟ',
    'book.notLinked': 'ଆପଣଙ୍କ ଲଗଇନ୍ ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ରୋଗୀ ରେକର୍ଡ ସହ ଯୋଡ଼ା ହୋଇନାହିଁ, ତେଣୁ ବୁକ୍ କରିହେବ ନାହିଁ। ଦୟାକରି କ୍ଲିନିକକୁ ଏହା ଯୋଡ଼ିବାକୁ କୁହନ୍ତୁ।',
    'book.change': 'ବଦଳାନ୍ତୁ',
    'book.addPatient': 'ନୂଆ ରୋଗୀ ଯୋଡ଼ନ୍ତୁ',
    'book.recent': 'ନିକଟରେ ଯୋଡ଼ା ବା ବଦଳା ଯାଇଥିବା',
    'book.searchHint': 'ରୋଗୀ ବାଛିବା ପାଇଁ ନାମ, ମୋବାଇଲ୍ କିମ୍ବା ରୋଗୀ କୋଡ୍ ଦ୍ୱାରା ଖୋଜନ୍ତୁ।',
    'book.selectTime': 'ସମୟ ବାଛନ୍ତୁ',
    'book.legendFree': 'ଖାଲି',
    'book.legendChosen': 'ବଛାଯାଇଛି',
    'book.legendBooked': 'ବୁକ୍',
    'book.legendPassed': 'ଗଲାଣି',
    'book.loadingSlots': 'ସ୍ଲଟ୍ ଲୋଡ୍ ହେଉଛି…',
    'book.closedReason': 'ବନ୍ଦ - {reason}। ଅନ୍ୟ ଦିନ ବାଛନ୍ତୁ।',
    'book.closed': 'ବନ୍ଦ ଅଛି। ଅନ୍ୟ ଦିନ ବାଛନ୍ତୁ।',
    'book.noSessionsDay': 'ଡାକ୍ତର ଏହି ଦିନ ରୋଗୀ ଦେଖନ୍ତି ନାହିଁ।',
    'book.slot.booked': 'ବୁକ୍ ହୋଇଛି',
    'book.slot.held': 'ଦେୟ ଚାଲିଛି',
    'book.slot.past': 'ସମୟ ଗଲାଣି',
    'book.followUpRate': 'ଫଲୋ-ଅପ୍ ଫି, {fee} ବଦଳରେ।',
    'book.followUpFee': 'ଫଲୋ-ଅପ୍ ଫି',
    'book.payNowQr': 'ସ୍ଲଟ୍ ନିଶ୍ଚିତ କରିବାକୁ {amount} QR ସ୍କାନ୍ କରି ଦିଆଯିବ।',
    'book.payNowUpi': 'ସ୍ଲଟ୍ ନିଶ୍ଚିତ କରିବାକୁ {amount} UPI ରେ ଦିଆଯିବ।',
    'book.payCash': 'କାଉଣ୍ଟରରେ ନଗଦ ଦେୟ। ରସିଦ ସେଠାରେ ମିଳିବ।',
    'book.payMethod': 'ଦେୟ ପଦ୍ଧତି',
    'book.holdNote': 'ଆପଣ ଦେୟ ଦେଉଥିବା ବେଳେ ସ୍ଲଟ୍ କିଛି ମିନିଟ୍ ପାଇଁ ଆପଣଙ୍କ ପାଇଁ ରଖାଯାଏ, ଏବଂ ଦେୟ ନିଶ୍ଚିତ ହେବା ମାତ୍ରେ ବୁକ୍ ହୋଇଯାଏ।',
    'book.override': 'ତଥାପି ବୁକ୍ କରନ୍ତୁ (ଓଭରରାଇଡ୍)',
    'book.overrideReason': 'ଓଭରରାଇଡ୍‌ର କାରଣ',
    'book.overridePh': 'ୱାକ୍-ଇନ୍ ରୋଗୀ ଆଗରୁ ଦେଖାଗଲେ, ଡାକ୍ତର ଡେରି ପର୍ଯ୍ୟନ୍ତ ରହିବାକୁ ରାଜି…',
    'book.overrideHint': 'ଏହା ଆପଣଙ୍କ ନାମ ସହ ବୁକିଂରେ ଲେଖାଯିବ।',
    'book.confirmMoveHead': 'ସମୟ ବଦଳ ନିଶ୍ଚିତ କରନ୍ତୁ',
    'book.confirmBookingHead': 'ଆପଣଙ୍କ ବୁକିଂ ନିଶ୍ଚିତ କରନ୍ତୁ',
    'book.paidNow': '{method} — ଏବେ ଦେୟ',
    'book.booking': 'ବୁକ୍ ହେଉଛି…',
    'book.confirmMoveBtn': 'ସମୟ ବଦଳାନ୍ତୁ',
    'book.confirmBookingBtn': 'ବୁକିଂ ନିଶ୍ଚିତ କରନ୍ତୁ',

    'book.qrFailed': 'QR ତିଆରି ହୋଇପାରିଲା ନାହିଁ। ଦୟାକରି ଅନ୍ୟ ଦେୟ ପଦ୍ଧତି ବ୍ୟବହାର କରନ୍ତୁ।',
    'book.scanToPayAlt': 'ଦେୟ ପାଇଁ ସ୍କାନ୍ କରନ୍ତୁ',
    'book.slotHeldUntil': 'ଆପଣ ଦେୟ ଦେବା ପର୍ଯ୍ୟନ୍ତ ଆପଣଙ୍କ ସ୍ଲଟ୍ {time} ପର୍ଯ୍ୟନ୍ତ ରଖାଯାଇଛି।',
    'book.errStartPayment': 'ଦେୟ ଆରମ୍ଭ ହୋଇପାରିଲା ନାହିଁ।',
    'book.errNotThrough': 'ଦେୟ ହୋଇପାରିଲା ନାହିଁ।',
    'book.notSeenYet': 'ଆମେ ଏପର୍ଯ୍ୟନ୍ତ ଦେୟ ଦେଖିପାରିନାହୁଁ। ଯଦି ଆପଣଙ୍କ ଆକାଉଣ୍ଟରୁ ଟଙ୍କା କଟିଛି, ତାହା ଶୀଘ୍ର ଦେଖାଯିବ।',
    'book.errQr': 'QR କୋଡ୍ ତିଆରି ହୋଇପାରିଲା ନାହିଁ।',
    'book.errSim': 'ଟେଷ୍ଟ ଦେୟ ହୋଇପାରିଲା ନାହିଁ।',
    'book.openingPayment': 'ସୁରକ୍ଷିତ ଦେୟ ଖୋଲୁଛି…',
    'book.payAmount': '{amount} ଦିଅନ୍ତୁ',
    'book.testMode': 'ଟେଷ୍ଟ ମୋଡ୍ — କୌଣସି ଟଙ୍କା କଟିବ ନାହିଁ। ବ୍ୟାଙ୍କ କ’ଣ ଉତ୍ତର ଦେବ ତାହା ବାଛନ୍ତୁ।',
    'book.approve': 'ମଞ୍ଜୁର · {mode}',
    'book.decline': 'ପ୍ରତ୍ୟାଖ୍ୟାନ',
    'book.scanQr': 'QR ସ୍କାନ୍ କରନ୍ତୁ',
    'book.redirect': 'ଦେୟ ପାଇଁ ଆପଣଙ୍କୁ {provider} କୁ ନିଆଯିବ। କ୍ଲିନିକ୍ ଆପଣଙ୍କ କାର୍ଡ କିମ୍ବା UPI ସୂଚନା କେବେ ଦେଖେ ନାହିଁ।',
    'book.notNow': 'ଏବେ ନୁହେଁ',
    'book.payByQrInstead': 'ଏହା ବଦଳରେ QR ସ୍କାନ୍ କରି ଦିଅନ୍ତୁ',
    'book.scanToPay': '{amount} ଦେବା ପାଇଁ ସ୍କାନ୍ କରନ୍ତୁ',
    'book.openUpiApp': 'ଯେକୌଣସି UPI ଆପ୍ ଖୋଲନ୍ତୁ — GPay, PhonePe, Paytm କିମ୍ବା ଆପଣଙ୍କ ବ୍ୟାଙ୍କ ଆପ୍ — ଏବଂ ଏହାକୁ ସ୍କାନ୍ କରନ୍ତୁ।',
    'book.waitingPayment': 'ଦେୟ ପାଇଁ ଅପେକ୍ଷା କରୁଛୁ…',
    'book.simulateScan': 'ଟେଷ୍ଟ ସ୍କାନ୍ କରନ୍ତୁ',
    'book.confirmingPayment': 'ଆପଣଙ୍କ ଦେୟ ନିଶ୍ଚିତ କରାଯାଉଛି…',
    'book.dontClose': 'ଦୟାକରି ଏହି ସ୍କ୍ରିନ୍ ବନ୍ଦ କରନ୍ତୁ ନାହିଁ କିମ୍ବା ପୁଣି ଦେୟ ଦିଅନ୍ତୁ ନାହିଁ।',
    'book.paidTitle': 'ଦେୟ ମିଳିଗଲା',
    'book.paidLine': '{amount} ଦିଆଗଲା — {title}।',
    'book.receiptNo': 'ରସିଦ {no}',
    'book.notCompleted': 'ଦେୟ ସମ୍ପୂର୍ଣ୍ଣ ହେଲା ନାହିଁ',
    'book.somethingWrong': 'କିଛି ଭୁଲ ହୋଇଗଲା।',
    'book.failedDraft': 'କୌଣସି ଟଙ୍କା କଟିନାହିଁ ଏବଂ ସ୍ଲଟ୍ ବୁକ୍ ହୋଇନାହିଁ। ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ, କିମ୍ବା ପଛକୁ ଯାଇ କ୍ଲିନିକରେ ଦେୟ ଦେବା ବାଛନ୍ତୁ।',
    'book.failedHeld': 'ଆପଣଙ୍କ ବୁକିଂ ଏବେ ବି ରଖାଯାଇଛି। ଆପଣ ପୁଣି ଚେଷ୍ଟା କରିପାରିବେ, କିମ୍ବା କ୍ଲିନିକରେ ଦେୟ ଦେଇପାରିବେ।',

    'book.errRecord': 'ଦେୟ ଲେଖାଯାଇପାରିଲା ନାହିଁ।',
    'book.recording': 'ଦେୟ ଲେଖାଯାଉଛି…',
    'book.recordTitle': '{amount} ମିଳିଥିବା ଲେଖନ୍ତୁ',
    'book.recordWarn': 'ଏହା କେବଳ କ୍ଲିନିକ୍ ପାଇସାରିଥିବା ଟଙ୍କା ଲେଖେ। ଏଥିରେ କାହାଠାରୁ ଟଙ୍କା କଟେ ନାହିଁ।',
    'book.txnNo': 'ଟ୍ରାନଜାକ୍ସନ୍ ନମ୍ବର',
    'book.txnPh': 'UTR, ଚେକ୍ ନମ୍ବର, UPI ରେଫରେନ୍ସ',
    'book.txnHint': 'ବ୍ୟାଙ୍କ କିମ୍ବା ଆପ୍ ଏହାକୁ ଯାହା ବି କୁହେ — ବ୍ୟାଙ୍କ ଷ୍ଟେଟମେଣ୍ଟ ସହ ଏହାକୁ ହିଁ ମିଳାଯାଏ।',
    'book.attachment': 'ଆଟାଚମେଣ୍ଟ (ଇଚ୍ଛାଧୀନ)',
    'book.attachHint': 'ଥିଲେ ସ୍କ୍ରିନସଟ୍, ରସିଦ କିମ୍ବା ସ୍କାନ୍ ଯୋଡ଼ନ୍ତୁ। PDF କିମ୍ବା ଫଟୋ, {mb} MB ପର୍ଯ୍ୟନ୍ତ।',
    'book.fileTooBig': 'ଏହି ଫାଇଲ୍ {mb} MB ରୁ ବଡ଼।',
    'book.noteOptional': 'ନୋଟ୍ (ଇଚ୍ଛାଧୀନ)',
    'book.notePh': 'ନିଯୁକ୍ତିଦାତା ଦେୟ ଦେଲେ, ଚେକ୍ ଶୁକ୍ରବାର କ୍ଲିୟର୍ ହେବ…',
    'book.recordPayment': 'ଦେୟ ଲେଖନ୍ତୁ',
    'book.enterTxnFirst': 'ସେଭ୍ କରିବା ପୂର୍ବରୁ ଟ୍ରାନଜାକ୍ସନ୍ ନମ୍ବର ଦିଅନ୍ତୁ।',

    'book.chooseDoctor': 'ଡାକ୍ତର ବାଛନ୍ତୁ',
    'book.filters': 'ଫିଲ୍ଟର୍',
    'book.searchDoctors': 'ଡାକ୍ତର ଖୋଜନ୍ତୁ',
    'book.searchDoctorsPh': 'ନାମ କିମ୍ବା ବିଶେଷଜ୍ଞତା ଦ୍ୱାରା ଖୋଜନ୍ତୁ',
    'book.specialties': 'ବିଶେଷଜ୍ଞତା',
    'book.filterDoctors': 'ଡାକ୍ତର ଫିଲ୍ଟର୍ କରନ୍ତୁ',
    'book.specialty': 'ବିଶେଷଜ୍ଞତା',
    'book.any': 'ଯେକୌଣସି',
    'book.feeUpTo': 'ପରାମର୍ଶ ଫି (ସର୍ବାଧିକ)',
    'book.nobodyQueued': 'ଆଜି ଏପର୍ଯ୍ୟନ୍ତ ଧାଡ଼ିରେ କେହି ନାହାନ୍ତି',
    'book.orderBy': 'କ୍ରମ',
    'book.sortRoster': 'ତାଲିକା ଅନୁସାରେ',
    'book.sortLoad': 'ସବୁଠାରୁ କମ୍ ରୋଗୀ',
    'book.clear': 'ସଫା କରନ୍ତୁ',
    'book.showN': '{n} ଦେଖାନ୍ତୁ',
    'book.noDoctorMatch': 'କୌଣସି ଡାକ୍ତର ମିଳିଲେ ନାହିଁ',
    'book.tryDifferent': 'ଅନ୍ୟ ନାମ କିମ୍ବା ବିଶେଷଜ୍ଞତା ଚେଷ୍ଟା କରନ୍ତୁ।',
    'book.viewProfile': 'ପ୍ରୋଫାଇଲ୍ ଦେଖନ୍ତୁ — {name}',
    'book.todayCount': 'ଆଜି {n}',
    'book.perConsultation': '/ପରାମର୍ଶ',
    'book.book': 'ବୁକ୍ କରନ୍ତୁ',
    'book.bio': '{name} କ୍ଲିନିକରେ {spec} ପରାମର୍ଶ ଦିଅନ୍ତି। ବୁକ୍ କରିବା ପୂର୍ବରୁ ଉପଲବ୍ଧତା ଏବଂ ଫଲୋ-ଅପ୍ ବିଷୟରେ ପଚାରି ନିଅନ୍ତୁ।',

    'book.recentChanges': 'ନିକଟର ପରିବର୍ତ୍ତନ',
    'book.onYourBehalf': 'ଆପଣଙ୍କ ତରଫରୁ',
    'book.errLoadBookings': 'ବୁକିଂ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'book.searchBooked': 'ବୁକ୍ ହୋଇଥିବା ରୋଗୀ ଖୋଜନ୍ତୁ',
    'book.searchBookedPh': 'ରୋଗୀଙ୍କ ନାମ, କୋଡ୍ କିମ୍ବା ମୋବାଇଲ୍',
    'book.filterStatus': 'ସ୍ଥିତି ଅନୁସାରେ ଫିଲ୍ଟର୍ କରନ୍ତୁ',
    'book.bucketDone': 'ସମ୍ପୂର୍ଣ୍ଣ',
    'book.filterPayment': 'ଦେୟ ଅନୁସାରେ ଫିଲ୍ଟର୍ କରନ୍ତୁ',
    'book.loadingBookings': 'ବୁକିଂ ଲୋଡ୍ ହେଉଛି…',
    'book.nobodyBookedOn': '{date} ରେ କୌଣସି ବୁକିଂ ନାହିଁ',
    'book.nobodyMatches': 'ଏହି ଫିଲ୍ଟର୍‌ରେ କେହି ମିଳିଲେ ନାହିଁ',
    'book.useArrows': 'ଅନ୍ୟ ଦିନ ଦେଖିବାକୁ ତୀର ବ୍ୟବହାର କରନ୍ତୁ।',
    'book.clearSearch': 'ଖୋଜା ସଫା କରନ୍ତୁ କିମ୍ବା ଅନ୍ୟ ଫିଲ୍ଟର୍ ବାଛନ୍ତୁ।',
    'book.amountPaid': '{amount} ଦିଆଗଲା',
    'book.amountDue': '{amount} ବାକି',
    'book.doctorNotFound': 'ଡାକ୍ତର ମିଳିଲେ ନାହିଁ।',
    'book.bookNow': 'ଏବେ ବୁକ୍ କରନ୍ତୁ',
    'book.doctorProfile': 'ଡାକ୍ତରଙ୍କ ପ୍ରୋଫାଇଲ୍',
    'book.perVisit': '/ପରିଦର୍ଶନ',
    'book.message': 'ବାର୍ତ୍ତା ପଠାନ୍ତୁ',
    'book.onFile': 'ରେକର୍ଡରେ ଅଛି',
    'book.qualifications': 'ଯୋଗ୍ୟତା',
    'book.notListed': 'ଲେଖାଯାଇନାହିଁ',
    'book.registration': 'ପଞ୍ଜୀକରଣ',
    'book.inQueueToday': 'ଆଜି ଧାଡ଼ିରେ',
    'book.tabAbout': 'ପରିଚୟ',
    'book.tabBooked': 'ବୁକିଂ',
    'book.tabAvailability': 'ଉପଲବ୍ଧତା',
    'book.tabReviews': 'ସମୀକ୍ଷା',
    'book.aboutDoctor': 'ଡାକ୍ତରଙ୍କ ବିଷୟରେ',
    'book.seeMore': 'ଅଧିକ ଦେଖନ୍ତୁ…',
    'book.credentials': 'ଯୋଗ୍ୟତା ଏବଂ ପଞ୍ଜୀକରଣ',
    'book.regNo': 'ପଞ୍ଜୀକରଣ ନଂ.',
    'book.missing': 'ଲେଖାଯାଇନାହିଁ',
    'book.consultation': 'ପରାମର୍ଶ',
    'book.followUpTerms_one': '{fee} · {n} ଦିନ ମଧ୍ୟରେ',
    'book.followUpTerms_other': '{fee} · {n} ଦିନ ମଧ୍ୟରେ',
    'book.phone': 'ଫୋନ୍',
    'book.clinic': 'କ୍ଲିନିକ୍',
    'book.reviewsHead': 'ସମୀକ୍ଷା ଓ ରେଟିଂ',
    'book.patientFeedback': 'ରୋଗୀଙ୍କ ମତାମତ',
    'book.reviewsNA': 'ସମୀକ୍ଷା ଏପର୍ଯ୍ୟନ୍ତ ଉପଲବ୍ଧ ନାହିଁ',
    'book.reviewsNABody': 'କ୍ଲିନିକ୍ ରୋଗୀଙ୍କ ମତାମତ ନେବା ଆରମ୍ଭ କଲେ ତାହା ଏଠାରେ ଦେଖାଯିବ।',
    'book.todaySessions': 'ଆଜିର ସେସନ୍',
    'book.closedTodayReason': 'ଆଜି ବନ୍ଦ — {reason}।',
    'book.closedToday': 'ଆଜି ବନ୍ଦ।',
    'book.noSessionsToday': 'ଆଜି ପାଇଁ କୌଣସି ସେସନ୍ ସ୍ଥିର ହୋଇନାହିଁ।',
    'book.sessionBooked': '{count} ବୁକ୍',
    'book.inTheQueue': 'ଧାଡ଼ିରେ',
    'book.yourList': 'ଆପଣଙ୍କ ତାଲିକା',
    'book.openConsult': 'ପରାମର୍ଶ କକ୍ଷ ଖୋଲନ୍ତୁ',
    'book.manageAvailability': 'ଉପଲବ୍ଧତା ପରିଚାଳନା କରନ୍ତୁ',
    'book.yourHours': 'ଆପଣଙ୍କ ସମୟ',
    'book.onBehalfOf': '{name} ଙ୍କ ତରଫରୁ',
    'book.onlyCanChange': 'କେବଳ {name}, ରିସେପ୍ସନ୍ କିମ୍ବା ଆଡମିନିଷ୍ଟ୍ରେଟର୍ ଏହି ସମୟ ବଦଳାଇପାରିବେ।',
  },
})
